var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff63ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#e211c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2007b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_1",
    x: 9,
    y: 15,
    width: 58.515,
    height: 51.238,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON",
    transform: "translate(-0.271 0.285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 76,
    height: 76,
    rx: 20,
    transform: "translate(0.271 -0.285)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "writing-tool_1_",
    "data-name": "writing-tool (1)",
    transform: "translate(18.271 20.214)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18, -20.5)",
    filter: "url(#Union_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1-2",
    "data-name": "Union 1",
    d: "M-1195.721-291.135v-17.8h3.561a1.187,1.187,0,0,1,1.187,1.187v14.834a1.187,1.187,0,0,1-.481.954l-2.55,1.891a1.181,1.181,0,0,1-.531.127A1.189,1.189,0,0,1-1195.721-291.135Zm-20.338-.591v-.594h1.52l.823.419c.375.185.768.33,1.155.491a1.757,1.757,0,0,1-1.717,1.464A1.781,1.781,0,0,1-1216.059-291.726Zm-5.936,0v-.714a6.009,6.009,0,0,0,1.187.12h2.374v.594a1.781,1.781,0,0,1-1.78,1.78A1.781,1.781,0,0,1-1221.995-291.726Zm-6.616.554a1.186,1.186,0,0,1-.456-1.31l1.07-3.6a1.173,1.173,0,0,1,.165-.343l1.114-1.591a5.918,5.918,0,0,0,2.5,4.6l-3,2.226a1.185,1.185,0,0,1-.707.234A1.186,1.186,0,0,1-1228.611-291.172Zm14.641-3.523h-6.837a3.556,3.556,0,0,1-3.561-3.561,3.571,3.571,0,0,1,3.561-3.56h6.139a9.354,9.354,0,0,0,6.57-2.723,1.185,1.185,0,0,0,0-1.678,1.187,1.187,0,0,0-1.679,0,6.945,6.945,0,0,1-3.848,1.922l5.808-8.3,7.543,3.652h2.179v14.98a17.214,17.214,0,0,1-7.28,1.638A17.576,17.576,0,0,1-1213.969-294.694Zm-17.146-7.528,6.542-10.3a3.546,3.546,0,0,1,1.588-1.357l4.515-1.961a3.761,3.761,0,0,1,1.453-.167l-12.761,18.225c-.029.041-.038.093-.066.136A3.555,3.555,0,0,1-1231.115-302.222Zm18.263-15.593,3.889,2.723-7.633,10.9h-4.211a5.862,5.862,0,0,0-1.8.311Zm1.362-1.944,2.042-2.918a1.186,1.186,0,0,1,1.653-.291l1.945,1.361a1.188,1.188,0,0,1,.292,1.654l-2.043,2.917Z",
    transform: "translate(1249.49 344.18)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrite);
export default __webpack_public_path__ + "static/media/icon-write.7fb42424a07bc4f8da0ca771fa47c092.svg";
export { ForwardRef as ReactComponent };